import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="dc-landing dc-dark dc-bg dc-text flex min-h-screen items-center justify-center px-4">
      <div className="text-center">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl dc-gradient-cta">
          <span className="text-lg font-bold text-white">D</span>
        </div>
        <h1 className="mt-8 text-7xl font-extrabold dc-gradient-text" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
          404
        </h1>
        <p className="mt-4 text-xl font-semibold dc-text">Page not found</p>
        <p className="mt-2 text-sm dc-text-muted max-w-sm">
          The page you're looking for doesn't exist or has moved.
        </p>
        <Button asChild className="mt-8 dc-gradient-cta text-white hover:opacity-90 border-0 rounded-lg">
          <Link to="/">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to home
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
